export const parseRatioToNumber = (r: string | number | undefined): number => {
  if (r === undefined || r === null) return 0;
  if (typeof r === 'number') return Number.isFinite(r) ? r : 0;
  const asStr = String(r).trim();
  if (asStr.includes('/')) {
    const [numS, denS] = asStr.split('/').map(s => s.trim());
    const num = parseFloat(numS);
    const den = parseFloat(denS);
    if (!Number.isFinite(num) || !Number.isFinite(den) || den === 0) return 0;
    return num / den;
  }
  const parsed = parseFloat(asStr);
  return Number.isFinite(parsed) ? parsed : 0;
};

export const getColorByLogP = (logP: number): string => {
  if (logP >= 8) return '#fc0314';
  if (logP <= 2) return '#1e01fd';
  if (logP <= 5) {
    const t = (logP - 2) / 3;
    return `rgb(${Math.round(30 + (197 - 30) * t)}, ${Math.round(1 + (0 - 1) * t)}, ${Math.round(253 + (143 - 253) * t)})`;
  }
  const t = (logP - 5) / 3;
  return `rgb(${Math.round(197 + (252 - 197) * t)}, ${Math.round(0 + (3 - 0) * t)}, ${Math.round(143 + (20 - 143) * t)})`;
};

export const tabs = ['GENES', 'VARIANTS'];

export const isDseaEnabled = process.env.NODE_ENV !== 'production' || process.env.REACT_APP_DSEA_ENABLED === 'true';

export const analysisMethodOptions = [
  {
    value: 'FISHER' as const,
    label: 'ORA (Over-representation analysis)',
    description: 'Tests whether disease-associated genes overlap significantly with your input list.',
  },
  {
    value: 'GSEA' as const,
    label: 'DSEA (DISGENET Score Enrichment Analysis)',
    description: 'Ranks genes by DISGENET association score and computes a running-sum enrichment statistic.',
  },
  {
    value: 'BOTH' as const,
    label: 'Run both and compare',
    description: 'Runs ORA first, then DSEA on the same gene list for side-by-side comparison.',
  },
];

export const getAnalysisMethodOptions = () =>
  isDseaEnabled ? analysisMethodOptions : analysisMethodOptions.filter(option => option.value === 'FISHER');

export const defaultGseaParams = {
  source: 'ALL',
  minScore: 0,
  maxScore: 1,
  exponent: 1,
  minCommonGenes: 2,
  minGeneSetSize: 15,
  maxGeneSetSize: 500,
  minHits: 5,
  nPermutations: 1000,
};

export const GSEA_MAX_GENES = 1000;

export const geneFilterOptions = [
  { value: 'geneSymbol', label: 'Gene symbol' },
  { value: 'ensemblId', label: 'Ensembl ID' },
  { value: 'uniprotId', label: 'UniProt ID' },
  { value: 'geneId', label: 'NCBI Gene ID' },
];
